import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ChangelogService } from '../service/changelog.service';
import * as ChangelogActions from './changelog.actions';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';

@Injectable()
export class ChangelogEffects {
  private actions$ = inject(Actions);
  private changelogService = inject(ChangelogService);

  getChangelog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ChangelogActions.loadChangelog),
      switchMap((action) => {
        return this.changelogService.getChangelog(action.language).pipe(
          map((_response) => ChangelogActions.loadChangelogSuccess({ changelog: _response })),
          catchError((error) => of(ChangelogActions.loadChangelogFailure({ error })))
        );
      })
    )
  );
}
